import { lazy } from "react";

// Pages principales - Lazy loaded
export const Index = lazy(() => import("@/pages/Index"));
export const Welcome = lazy(() => import("@/pages/Welcome"));
export const Auth = lazy(() => import("@/pages/Auth"));
export const AuthCallback = lazy(() => import("@/pages/AuthCallback"));
export const ResetPassword = lazy(() => import("@/pages/ResetPassword"));
export const Pets = lazy(() => import("@/pages/Pets"));
export const AddPet = lazy(() => import("@/pages/AddPet"));
export const EditPet = lazy(() => import("@/pages/EditPet"));
export const PetDetails = lazy(() => import("@/pages/PetDetails"));
export const Profile = lazy(() => import("@/pages/Profile"));
export const Health = lazy(() => import("@/pages/Health"));
export const Gallery = lazy(() => import("@/pages/Gallery"));
export const Calendar = lazy(() => import("@/pages/Calendar"));
export const BreedersList = lazy(() => import("@/pages/BreedersList"));
export const BreederDetail = lazy(() => import("@/pages/BreederDetail"));
export const BreederEdit = lazy(() => import("@/pages/BreederEdit"));
export const BreederDashboard = lazy(() => import("@/pages/BreederDashboard"));
export const Shop = lazy(() => import("@/pages/Shop"));
export const NotFound = lazy(() => import("@/pages/NotFound"));
export const Subscription = lazy(() => import("@/pages/Subscription"));
export const SubscriptionUpgrade = lazy(
  () => import("@/pages/SubscriptionUpgrade"),
);
export const AdminMetrics = lazy(() => import("@/pages/AdminMetrics"));
export const Competitions = lazy(() => import("@/pages/Competitions"));
export const LostPets = lazy(() => import("@/pages/LostPets"));
export const CreateLostPet = lazy(() => import("@/pages/CreateLostPet"));
export const LostPetDetails = lazy(() => import("@/pages/LostPetDetails"));
export const InsuranceComparison = lazy(
  () => import("@/pages/InsuranceComparison"),
);
export const SmartReminders = lazy(() => import("@/pages/SmartReminders"));
export const AIAssistant = lazy(() => import("@/pages/AIAssistant"));

// Pages santé - Lazy loaded
export const VaccinesList = lazy(() => import("@/pages/VaccinesList"));
export const AddVaccine = lazy(() => import("@/pages/AddVaccine"));
export const MedicationsList = lazy(() => import("@/pages/MedicationsList"));
export const AddMedication = lazy(() => import("@/pages/AddMedication"));
export const DewormingList = lazy(() => import("@/pages/DewormingList"));
export const AddDeworming = lazy(() => import("@/pages/AddDeworming"));
export const HygienePage = lazy(() => import("@/pages/HygienePage"));
export const AddHygienePage = lazy(() => import("@/pages/AddHygienePage"));

// Pages détails animal - Lazy loaded
export const PetPhotos = lazy(() => import("@/pages/PetPhotos"));
export const PetNotes = lazy(() => import("@/pages/PetNotes"));
export const PetLocations = lazy(() => import("@/pages/PetLocations"));
export const VeterinaryDocuments = lazy(
  () => import("@/pages/VeterinaryDocuments"),
);
export const PetGPSTrackers = lazy(() => import("@/pages/PetGPSTrackers"));
export const GPSTracking = lazy(() => import("@/pages/GPSTracking"));

// Pages suivi santé - Lazy loaded
export const WeightTracking = lazy(() => import("@/pages/WeightTracking"));
export const ActivityTracking = lazy(() => import("@/pages/ActivityTracking"));
export const AddActivity = lazy(() => import("@/pages/AddActivity"));
export const FoodTracking = lazy(() => import("@/pages/FoodTracking"));

// Pages exotic health - Lazy loaded
export const ExoticHealth = lazy(() => import("@/pages/ExoticHealth"));
export const TemperatureTracking = lazy(
  () => import("@/pages/exotic/TemperatureTracking"),
);
export const HumidityTracking = lazy(
  () => import("@/pages/exotic/HumidityTracking"),
);
export const AddTemperature = lazy(
  () => import("@/pages/exotic/AddTemperature"),
);
export const AddHumidity = lazy(() => import("@/pages/exotic/AddHumidity"));
export const TemperatureHistory = lazy(
  () => import("@/pages/exotic/TemperatureHistory"),
);
export const HumidityHistory = lazy(
  () => import("@/pages/exotic/HumidityHistory"),
);

// Pages info santé - Lazy loaded
export const PracticalInfo = lazy(() => import("@/pages/PracticalInfo"));
export const InsuranceInfo = lazy(() => import("@/pages/health/InsuranceInfo"));
export const InsurancesList = lazy(
  () => import("@/pages/health/InsurancesList"),
);
export const TrainerInfo = lazy(() => import("@/pages/health/TrainerInfo"));

// Pages vétérinaires - Lazy loaded
export const VetsPage = lazy(() => import("@/pages/VetsPage"));
export const FindVeterinarian = lazy(() => import("@/pages/FindVeterinarian"));

// Forum social - Lazy loaded avec named export
export const SocialForum = lazy(() =>
  import("@/pages/SocialForum").then((module) => ({
    default: module.SocialForum,
  })),
);
// Pages légales
export const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
export const TermsOfService = lazy(() => import("@/pages/TermsOfService"));
export const LegalMentions = lazy(() => import("@/pages/LegalMentions"));
export const RefundPolicy = lazy(() => import("@/pages/RefundPolicy"));

// Page publique QR code (sans auth)
export const PublicPetProfile = lazy(() => import("@/pages/PublicPetProfile"));

// PWA Share Target
export const ShareReceiver = lazy(() => import("@/pages/ShareReceiver"));
